import { createPlayer } from '@zattoo/playback-sdk';
export const init = () => {
    // nothing to initialize for apple
    // but keep the function for compatibility with other platforms
    return Promise.resolve();
};
export { PlayerView, } from './player-view';
export { createPlayer, };
